/**
 * Translate 취소용 geometry 스냅샷
 * @param {import('ol/Feature').default[]} movedFeatures
 * @param {import('ol/Feature').default[]} allFeatures
 * @param {(f: import('ol/Feature').default) => string|null} readStringSeq
 */
export function buildTranslateGeometrySnapshot(movedFeatures, allFeatures, readStringSeq) {
  /** @type {Array<{ feature: import('ol/Feature').default, geometry: import('ol/geom/Geometry').default }>} */
  const entries = [];
  const seen = new Set();

  const capture = feature => {
    if (!feature || seen.has(feature)) {
      return;
    }
    const geometry = feature.getGeometry()?.clone?.();
    if (!geometry) {
      return;
    }
    seen.add(feature);
    entries.push({ feature, geometry });
  };

  movedFeatures.forEach(feature => {
    capture(feature);
    const stringSeq = readStringSeq(feature);
    if (stringSeq == null) {
      return;
    }
    allFeatures.forEach(candidate => {
      const type = (candidate.get('featureType') || '').toLowerCase();
      if (type !== 'module') {
        return;
      }
      if (readStringSeq(candidate) === stringSeq) {
        capture(candidate);
      }
    });
  });

  return entries;
}

/** @param {Array<{ feature: import('ol/Feature').default, geometry: import('ol/geom/Geometry').default }>} snapshot */
export function revertTranslateGeometrySnapshot(snapshot) {
  if (!snapshot?.length) {
    return false;
  }
  snapshot.forEach(({ feature, geometry }) => {
    feature.setGeometry(geometry.clone());
  });
  return true;
}
